import React, { useCallback, useEffect, useState } from 'react';
import { Box, FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';
import api from '../config/api';

const PartnerTeamMemberFilter = ({
  value,
  onChange,
  isPartnerUser = false,
  getAuthHeaders,
  testId = 'partner-team-member-filter',
  sx,
}) => {
  const { t } = useTranslation();
  const [teamMembers, setTeamMembers] = useState([]);

  const loadTeamMembers = useCallback(async () => {
    if (!getAuthHeaders) return;
    try {
      const response = await api.get('/partners/team-members', {
        headers: getAuthHeaders(),
      });
      if (response.data?.users) {
        setTeamMembers(response.data.users);
      }
    } catch (err) {
      console.error('Failed to load team members:', err);
    }
  }, [getAuthHeaders]);

  useEffect(() => {
    loadTeamMembers();
  }, [loadTeamMembers]);

  return (
    <Box sx={[{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center', py: 1.5 }, sx]}>
      <FormControl size="small" sx={{ minWidth: 220 }}>
        <InputLabel id={`${testId}-label`}>
          {t('partnerLists.teamMemberFilter')}
        </InputLabel>
        <Select
          labelId={`${testId}-label`}
          label={t('partnerLists.teamMemberFilter')}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          data-testid={testId}
        >
          <MenuItem value="all">{t('partnerLists.teamFilterAll')}</MenuItem>
          {isPartnerUser ? (
            <MenuItem value="mine">{t('partnerLists.teamFilterMine')}</MenuItem>
          ) : null}
          <MenuItem value="anyone">{t('partnerLists.teamFilterAnyone')}</MenuItem>
          {teamMembers.map((member) => (
            <MenuItem key={member.id} value={String(member.id)}>
              {member.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default PartnerTeamMemberFilter;
